module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1003-7f5e5b8e652ea1b4219531cec2e9ad3d.png";